import * as types from '../../actionTypes';

const initialState = {
    medicineDeactivateInfo: [],
    error: {},
    loading: false
}


export const medicineDeactivateReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.MEDICINE_DEACTIVATE_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.MEDICINE_DEACTIVATE_SUCCESS:
            console.log("action.payload",action.payload)
            return {
                ...state,
                medicineDeactivateInfo: action.payload,
                loading: false,
                error: {}
            }
        case types.MEDICINE_DEACTIVATE_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
            } 


        default:
            return state;
    }
}